'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const CardTitleDivider = styled(Box)(({theme}) => ({
    backgroundImage:
        'linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)',
    backgroundSize: '1rem 1rem',
    backgroundColor: theme.palette.custom?.mustard,
    borderRadius: '.25rem',
    paddingTop: '.25rem',
    width: '100%',
    height: '0'
}));

export default CardTitleDivider;
